import { useState, memo } from "react";
import ValorDataCaixa from "./ValorDataCaixa";
import "./CreditoTab.scss";

import moment from "moment";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import InputSelect from "../../../../../../../shared/components/inputs/InputSelect/InputSelect";

function CreditoTab({
  valor,
  handleCloseModalReceber,
  receberHandler,
  totalPorReceber,
  caixas,
  parcela,
  cliente,
  modoContingenciaAtivo,
  parcelaTemFTE,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cartao, setCartao] = useState("Vinti4");
  const [dadosValorDataCaixa, setDadosValorDataCaixa] = useState({
    valor: valor,
    data: moment(),
    caixa: caixas[0].id,
    observacao: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const changeValorDataCaixa = (data) => {
    setDadosValorDataCaixa(data);
  };

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [pendingOperation, setPendingOperation] = useState(null);

  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDialogConfirm = () => {
    setOpenConfirmDialog(false);
    setIsSubmitting(true);

    // Executar a operação pendente que foi armazenada
    if (pendingOperation) {
      receberHandler(
        {
          quantiaPaga: Number(dadosValorDataCaixa.valor),
          metodoPagamento: "Cartão de crédito",
          cartao: cartao,
          dataPagamento: dadosValorDataCaixa.data,
          caixa: dadosValorDataCaixa.caixa,
          parcelaPaga: dadosValorDataCaixa.valor === valor,
          quantiaPorPagar: valor - dadosValorDataCaixa.valor,
          observacao: dadosValorDataCaixa.observacao,
        },
        pendingOperation,
      );
    }
  };

  const preReceberHandler = (e, emitir) => {
    let mensagemDeErro = "";

    if (!dadosValorDataCaixa.data) {
      mensagemDeErro = "Introduza a data de recebimento";
      setErrorMessage(mensagemDeErro);
    } else if (
      !moment.isMoment(dadosValorDataCaixa.data) ||
      !dadosValorDataCaixa.data.isValid()
    ) {
      mensagemDeErro = "Introduza a data de recebimento corretamente";
      setErrorMessage(mensagemDeErro);
    } else if (parcelaTemFTE && Number(dadosValorDataCaixa.valor) > valor) {
      // Parcela com FTE: não pode pagar mais que o valor da parcela
      // (o merge é bloqueado no backend; aqui damos a mensagem explicativa).
      mensagemDeErro = `Esta parcela tem uma FTE emitida. O valor a receber não pode exceder ${valor}$00.`;
      setErrorMessage(mensagemDeErro);
    }

    if (!isSubmitting && !mensagemDeErro) {
      if (emitir && cliente?.nome !== cliente?.nomeFiscal) {
        // Mostrar diálogo de confirmação
        // Guardar a operação pendente e mostrar o dialog
        setPendingOperation(emitir);
        setOpenConfirmDialog(true);
      } else {
        setIsSubmitting(true);
        receberHandler(
          {
            quantiaPaga: Number(dadosValorDataCaixa.valor),
            metodoPagamento: "Cartão de crédito",
            cartao: cartao,
            dataPagamento: dadosValorDataCaixa.data,
            caixa: dadosValorDataCaixa.caixa,
            parcelaPaga: dadosValorDataCaixa.valor === valor,
            quantiaPorPagar: valor - dadosValorDataCaixa.valor,
            observacao: dadosValorDataCaixa.observacao,
          },
          emitir,
        );
      }
    }
  };

  const cartaoChangeHandler = (value) => {
    setCartao(value);
  };

  return (
    <div className="credito__tab__container">
      <InputSelect
        handleChange={cartaoChangeHandler}
        label="Cartão"
        initialValue={cartao}
        items={["Vinti4", "Visa", "MasterCard"]}
      />
      <ValorDataCaixa
        valor={valor}
        changeValorDataCaixa={changeValorDataCaixa}
        caixas={caixas}
        totalPorReceber={totalPorReceber}
        tab="credito"
      />
      {errorMessage && (
        <span className="fluxo-atendimento__modal__erros">{errorMessage}</span>
      )}
      <div className="fluxo-atendimento__modal__bottom_btns">
        <span
          className="cancel-btn"
          onClick={handleCloseModalReceber}
          style={{ display: "block" }}
        >
          Fechar
        </span>

        <span
          className="blue-button"
          disabled={isSubmitting}
          onClick={preReceberHandler}
        >
          {isSubmitting ? "Recebendo..." : "Receber"}
        </span>

        {!parcela.documentoEletronico &&
          !parcelaTemFTE &&
          (parcela.cancelamentosDocumentosEletronicos?.length === 0 ||
            (parcela.cancelamentosDocumentosEletronicos?.length > 0 &&
              parcela.cancelamentosDocumentosEletronicos[
                parcela.cancelamentosDocumentosEletronicos?.length - 1
              ]?.documentoCancelamento?.succeeded === true)) && (
            <span
              className="blue-button"
              disabled={isSubmitting}
              onClick={preReceberHandler.bind(null, null, "emitirFRE")}
            >
              {isSubmitting
                ? "Recebendo..."
                : `Receber e emitir FRE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          )}
      </div>
      {/* Dialog de confirmação */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({cliente?.nome}) e o nome fiscal (
            {cliente?.nomeFiscal}) são diferentes. Deseja prosseguir com a
            emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default memo(CreditoTab);
